// @flow

import styled from 'styled-components';
import { InputBase } from './base';

export const Input = styled.input`
    ${InputBase};
`;
